module.exports = __webpack_public_path__ + "5b8c3e84fe86a5314d91e31af74f5934.jpg";